export default "__VITE_ASSET__DVePs7Ra__"